import React, { Component } from 'react';
import { Container, Card, Form } from 'react-bootstrap';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import Footers from '../../component/Footers/Footer';
import DatePicker from 'react-datepicker';
import { format, subYears } from 'date-fns';
import Loader from '../../component/Loader/Loader';
import Headers from '../../component/Headers/Headers';
import 'react-datepicker/dist/react-datepicker.css';
import ErrorModal from '../../component/ErrorModal/ErrorModal';
import { useRecaptcha } from '../../hooks/useRecaptcha';

const MAX_CAPTCHA_ATTEMPTS = 3;
const V2_CONTAINER_ID = 'student-info-recaptcha-v2';

class Login extends Component {
  state = {
    validated: false,
    setValidated: false,
    StudentID: '',
    DOB: '',
    Email: '',
    isValidRecaptcha: true,
    SiteKey: '',
    showV2Captcha: false,
    captchaAttempts: 0,
    isSubmitting: false
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.showV2Captcha || prevState.showV2Captcha === this.state.showV2Captcha) return;

    this.props.recaptcha.renderV2Widget(V2_CONTAINER_ID, token => {
      this.submitStudentInfo(token, 'v2');
    }).catch(() => {
      this.displayError('Please try again with valid captcha');
    });
  }

  handleChange = date => {
    this.setState({
      DOB: date
    });
  };

  resetCaptchaFlow = () => {
    this.props.recaptcha.resetV2Widget();
    this.setState({
      showV2Captcha: false,
      captchaAttempts: 0,
      isSubmitting: false
    });
  };

  displayError = message => {
    this.setState({
      isLoading: false,
      isSubmitting: false,
      show: true,
      errorMsg: message
    });
  };

  submitStudentInfo = async (token, captchaType) => {
    const studentInfo = {
      StudentID: this.state.StudentID,
      DOB: format(this.state.DOB, 'dd/MM/yyyy'),
      Email: this.state.Email,
      token,
      captchaType
    };

    try {
      const response = await axios.post(process.env.REACT_APP_VALIDATESTUDENTINFO, studentInfo);
      const result = response.data;

      if (result.isValidStudent) {
        this.setState({ isLoading: false, isSubmitting: false });
        this.resetCaptchaFlow();

        localStorage.clear();

        this.props.history.push({
          pathname: '/PhotoGuide',
          state: {
            accesstoken: result.accessToken,
            studentID: this.state.StudentID,
            userType: 'Student'
          }
        });
      } else if (result.requireV2Captcha) {
        const attempts = this.state.captchaAttempts + 1;
        if (attempts >= MAX_CAPTCHA_ATTEMPTS) {
          this.resetCaptchaFlow();
          this.displayError('Please try again with valid captcha');
          return;
        }

        this.setState({
          isLoading: false,
          isSubmitting: true,
          showV2Captcha: true,
          captchaAttempts: attempts
        });
      } else if (result.validationRemarks === 'Invalid captcha') {
        this.resetCaptchaFlow();
        this.displayError('Please try again with valid captcha');
      } else {
        this.resetCaptchaFlow();
        this.displayError('Please try again with valid student information');
      }
    } catch (error) {
      this.resetCaptchaFlow();
      if (error.response) {
        this.displayError(error.response.status + ' ' + error.response.statusText);
      } else {
        this.displayError(error.message);
      }
    }
  };

  submitHandler = async e => {
    const form = e.currentTarget;

    const isValidChar = /(([^<>()[\]\.,;:\s@"]+(\.[^<>()[\]\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})+$/.test(this.state.Email);
    let isValidDate = false;

    if (this.state.DOB) {
      isValidDate = /^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]\d{4}$/.test(format(this.state.DOB, 'dd/MM/yyyy'));
    }

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();

      this.setState({
        errorMsg: 'All fields are required',
        show: true
      });
    } else if (!isValidChar) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        errorMsg: 'Invalid Email',
        show: true
      });
    } else if (!isValidDate) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        errorMsg: 'Invalid Date',
        show: true
      });
    } else {
      e.preventDefault();
      if (this.state.isSubmitting || this.props.recaptcha.loading || this.props.recaptcha.error) return;

      this.setState({ setValidated: true, isLoading: true, isSubmitting: true, show: false });

      try {
        const token = await this.props.recaptcha.executeV3();
        if (!token) throw new Error('Please try again with valid captcha');
        await this.submitStudentInfo(token, 'v3');
      } catch (error) {
        this.resetCaptchaFlow();
        this.displayError(error.message);
      }
    }
  }

  changeHandler = e => {
    const target = e.target;
    const name = target.name;

    if (name === 'StudentID') {
      const isValidChar = !/(([^<>()[\]\.,;:\s@"]+(\.[^<>()[\]\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})+$/.test(this.state.Email);
      if (isValidChar && e.target.value.length <= 20) {
        this.setState({ StudentID: e.target.value });
      }
    }

    if (name === 'Email') {
      this.setState({ Email: e.target.value });
    }
  }

  closeHandler = () => {
    this.setState({ show: false });
  }

  render() {
    const { recaptcha } = this.props;

    return (
      <div>
        <Headers />
        <Container className="col-md-6">
          {(this.state.isLoading || recaptcha.loading) ? <Loader isLoading={this.state.isLoading || recaptcha.loading} /> : null}
          <Card className="mt-5">
            <Card.Header className="bg-brandcolor text-center">
              <h5 className="text-white">Student Information</h5>
            </Card.Header>
            <Card.Body>
              <Form className={this.state.validate} noValidate validated={this.state.validated} onSubmit={event => { this.submitHandler(event); }}>
                <Form.Group controlId="validationCustom01">
                  <Form.Label className="text-success"><b>Student ID:</b></Form.Label>
                  <Form.Label className="text-danger"><b>*</b></Form.Label>
                  <Form.Control
                    type="text"
                    name="StudentID"
                    required
                    max="20"
                    value={this.state.StudentID}
                    onChange={event => { this.changeHandler(event); }}
                  />
                  {/* <Form.Control.Feedback type="invalid">{this.state.validationMsg}</Form.Control.Feedback>                               */}
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-success"><b>Date Of Birth:</b></Form.Label>
                  <Form.Label className="text-danger"><b>*</b></Form.Label>
                  <DatePicker
                    className="form-control"
                    selected={this.state.DOB}
                    onChange={this.handleChange}
                    dateFormat="dd/MM/yyyy"
                    maxDate={subYears(new Date(), 15)}
                    placeholderText="dd/MM/yyyy"
                    showYearDropdown
                    yearDropdownItemNumber={15}
                    scrollableYearDropdown
                  />
                </Form.Group>
                <Form.Group controlId="validationCustom03">
                  <Form.Label className="text-success"><b>Email:</b></Form.Label>
                  <Form.Label className="text-danger"><b>*</b></Form.Label>
                  <Form.Control
                    type="text"
                    name="Email"
                    required
                    value={this.state.Email}
                    onChange={event => { this.changeHandler(event); }}
                  />
                  {/* <Form.Control.Feedback type="invalid">{this.state.validationMsg}</Form.Control.Feedback>                               */}
                </Form.Group>
                {this.state.showV2Captcha ? <div id={V2_CONTAINER_ID} className="mt-3" /> : null}
                {recaptcha.error ? <button type="button" className="btn btn-outline-secondary w-100 mt-3" onClick={recaptcha.retry}>Retry captcha configuration</button> : null}
                <Form.Group>
                  <input type="submit" className="btn btn-success btn-lg w-100 mt-3" value={this.state.isSubmitting ? 'Submitting...' : 'Submit'} disabled={this.state.isSubmitting || recaptcha.loading || !!recaptcha.error} />
                </Form.Group>
              </Form>

            </Card.Body>
          </Card>

        </Container>
        <ErrorModal msg={recaptcha.error ? 'Captcha configuration is unavailable' : this.state.errorMsg} show={this.state.show || !!recaptcha.error} click={() => this.closeHandler()} />
        <Footers />
      </div>

    );
  }
}

function LoginWithRecaptcha(props) {
  const recaptcha = useRecaptcha();
  return <Login {...props} recaptcha={recaptcha} />;
}

export default withRouter(LoginWithRecaptcha);
